module.exports = __webpack_public_path__ + "static/media/7.11d60493.png";